// extracted by mini-css-extract-plugin
export default {"shortText":"PlaygroundTokenUsageWidget-module__shortText--uzb1I","longText":"PlaygroundTokenUsageWidget-module__longText--SyCHb"};